import Route from '@ember/routing/route';

export default class ClassGroupClassRoute extends Route 
{
	model(params) 
	{
		return params.class_id;
	}
}
